import React, { useEffect, useState } from 'react'
import ConfirmModal from './Confirm.modal';
import { Col, Form, Row } from 'react-bootstrap';
import DatePicker from "react-datepicker"
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import AdminService from '../../services/admin.service';
import toast from 'react-hot-toast';

interface IProps {
    userId: string;
    handleClose: () => void;
    reload: () => void
}


export default function EditReverificationOperatorModal({ userId, handleClose, reload }: IProps) {
    const [data, setData] = useState<any>(null);

    function handleChangeData(e: any) {
        setData({ ...data, [e.target.name]: e.target.value });
    }

    async function updateUser() {

        if (!data?.emailId || !data?.userName || !data?.accessStartTime || !data?.accessEndTime) {
            toast.error("All fields are required");
            return;
        }

        let payload = {
            emailId: data?.emailId,
            userName: data?.userName,
            collegeName: data?.collegeName,
            collegId: data?.collegId,
            accessStartTime: data?.accessStartTime,
            accessEndTime: data?.accessEndTime,
            examId: data?.examId,
            // stream: data?.stream,
        }

        await AdminService.updateReverificationUser(userId, payload)
            .then((res) => {
                if (res.status === 200) {
                    toast.success("Operator updated successfully");
                    onModalClose();
                    reload();
                }
            })
            .catch((err) => {
                console.log(err);
                toast.error("Error in updating operator");
            });
    }

    console.log(data, "data")


    async function getUserDetails() {
        await AdminService.getReverificationUser(userId)
            .then((res) => {
                if (res.status === 200) {
                    setData(res?.data?.data?.operator);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    function onModalClose() {
        setData(null);
        handleClose();
    }

    useEffect(() => {
        if (userId) {
            getUserDetails();
        }
    }, [userId])

    return (
        <>
            <ConfirmModal
                titleText={"Update reverification operator"}
                size="lg"
                bodyText={
                    <>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <label className="fw-bold xcn-text-12 text-secondary">
                                    Operator Username
                                </label>
                                <Form.Control
                                    type="userName"
                                    defaultValue={data?.userName}
                                    name = "userName"
                                    onChange={(e: any) => handleChangeData(e)}
                                />
                            </Form.Group>
                             <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <label className="fw-bold xcn-text-12 text-secondary">
                                    Operator Email
                                </label>
                                <Form.Control
                                    type="text"
                                    defaultValue={data?.emailId}
                                    name = "emailId"
                                    onChange={(e: any) => handleChangeData(e)}
                                />
                            </Form.Group>
                             <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <label className="fw-bold xcn-text-12 text-secondary">
                                   College ID
                                </label>
                                <Form.Control
                                    type="text"
                                    defaultValue={data?.collegId}
                                    name = "collegeId"
                                    onChange={(e: any) => handleChangeData(e)}
                                />
                            </Form.Group>
                             <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <label className="fw-bold xcn-text-12 text-secondary">
                                    College Name
                                </label>
                                <Form.Control
                                    type="text"
                                    defaultValue={data?.collegeName}
                                    name = "collegeName"
                                    onChange={(e: any) => handleChangeData(e)}
                                />
                            </Form.Group>
                            {/* <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <label className="fw-bold xcn-text-12 text-secondary">
                                    Stream
                                </label>
                                <Form.Control
                                    type="text"
                                    value={data?.stream}
                                    onChange={(e: any) => handleChangeData(e)}
                                />
                            </Form.Group> */}
                            <Row className="mt-2">
                                <Col>
                                    <label className="fw-bold xcn-text-12 text-secondary">
                                        Start Time
                                    </label>
                                    <DatePicker
                                        dateFormat="yyyy/MM/dd h:mm aa"
                                        showTimeSelect
                                        selected={moment(data?.accessStartTime).toDate()}
                                        name="accessStartTime"
                                        onChange={(e) => {
                                            handleChangeData({
                                                target: { name: "accessStartTime", value: e },
                                            });
                                        }}
                                        className="form-control xcn-text-12"
                                        minDate={new Date()}
                                    />
                                </Col>
                                <Col md>
                                    <label className="fw-bold xcn-text-12 text-secondary">
                                        End Time
                                    </label>
                                    <DatePicker
                                        dateFormat="yyyy/MM/dd h:mm aa"
                                        showTimeSelect
                                        name="accessEndTime"
                                        selected={moment(data?.accessEndTime).toDate()}
                                        onChange={(e) => {
                                            handleChangeData({
                                                target: { name: "accessEndTime", value: e },
                                            });
                                        }}
                                        className="form-control xcn-text-12"
                                        minDate={new Date()}
                                    />
                                </Col>
                            </Row>
                        </Form.Group>
                    </>
                }
                show={userId !== ""}
                onHide={onModalClose}
                button={[
                    {
                        label: (
                            <>
                                <FontAwesomeIcon icon={faXmarkCircle} /> Cancel
                            </>
                        ),
                        action: onModalClose,
                        variant: "secondary",
                    },
                    {
                        label: (
                            <>
                                <FontAwesomeIcon icon={faCheck} /> Save
                            </>
                        ),
                        action: updateUser,
                        variant: "success",
                    },
                ]}
            />

        </>
    )
}